// src/pages/EmConstrucaoPage.jsx
import React from "react";
import { FaTools, FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const EmConstrucaoPage = () => {
    const navigate = useNavigate();

    return (
        <div style={ui.page}>
            {/* Header */}
            <div style={ui.headerBar}>
                <h1 style={ui.headerTitle}>🚧 Módulo em Construção</h1>
                <button onClick={() => navigate("/dashboard")} style={ui.headerButton}>
                    <FaHome style={{ marginRight: 8 }} /> Voltar
                </button>
            </div>

            {/* Conteúdo */}
            <div style={ui.card}>
                <div style={ui.centerContent}>
                    <FaTools style={{ fontSize: 80, color: "#667eea", marginBottom: 20 }} />
                    <h2 style={ui.title}>Estamos trabalhando nisso!</h2>
                    <p style={ui.text}>
                        Este módulo ainda está em desenvolvimento. Em breve você poderá acessar
                        todas as funcionalidades do controle de <strong>CND</strong> e{" "}
                        <strong>Parcelamentos</strong>.
                    </p>
                    <button onClick={() => navigate("/dashboard")} style={ui.buttonPrimary}>
                        <FaHome style={{ marginRight: 8 }} /> Voltar ao Painel
                    </button>
                </div>
            </div>
        </div>
    );
};

const ui = {
    page: {
        padding: 24,
        backgroundColor: "#f8fafc",
        minHeight: "95vh",
        width: "100%",
        maxWidth: "1200px",
        margin: "0 auto",
        boxSizing: "border-box",
        marginBottom: 40,
    },
    headerBar: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 24,
        marginBottom: 24,
        border: "1px solid #e5e7eb",
        borderRadius: "16px",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
        color: "#fff",
    },
    headerTitle: {
        margin: 0,
        fontSize: "1.5rem",
        fontWeight: 600,
    },
    headerButton: {
        backgroundColor: "rgba(255,255,255,0.15)",
        color: "#fff",
        padding: "10px 16px",
        borderRadius: 10,
        border: "2px solid rgba(255,255,255,0.25)",
        cursor: "pointer",
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
    },
    card: {
        backgroundColor: "#ffffff",
        borderRadius: 12,
        border: "1px solid #e5e7eb",
        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
        padding: 40,
        marginBottom: 24,
    },
    centerContent: {
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },
    title: {
        fontSize: "1.75rem",
        fontWeight: 600,
        color: "#1f2937",
        marginBottom: 12,
    },
    text: {
        fontSize: "1rem",
        color: "#374151",
        maxWidth: 500,
        marginBottom: 24,
        lineHeight: 1.6,
    },
    buttonPrimary: {
        backgroundColor: "#667eea",
        color: "#ffffff",
        padding: "12px 20px",
        borderRadius: 8,
        border: "2px solid #667eea",
        cursor: "pointer",
        fontWeight: 600,
        fontSize: "0.9rem",
        display: "flex",
        alignItems: "center",
    },
};

export default EmConstrucaoPage;
